const BRAND = "#305478";
const BRAND_LIGHT = "#4a7fad";
const SUCCESS = "#16a34a";
const WARNING = "#d97706";
const MUTED = "#94a3b8";

export const CHART_COLORS = {
  starts: BRAND,
  completions: SUCCESS,
  inProgress: BRAND_LIGHT,
  dropped: "#dc2626",
  errors: WARNING,
  muted: MUTED,
  pie: [SUCCESS, "#f59e0b", "#dc2626"],
};

function formatDayLabel(date) {
  return date.toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "short",
  });
}

function buildDailySeries(values) {
  const days = values.length;

  return values.map((item, index) => {
    const date = new Date();
    date.setDate(date.getDate() - (days - 1 - index));

    return {
      date: formatDayLabel(date),
      starts: item.starts,
      completions: item.completions,
    };
  });
}

const DEMO_CHARTS = [
  {
    daily: buildDailySeries([
      { starts: 48, completions: 32 },
      { starts: 52, completions: 38 },
      { starts: 61, completions: 44 },
      { starts: 55, completions: 41 },
      { starts: 58, completions: 43 },
      { starts: 72, completions: 54 },
      { starts: 68, completions: 49 },
      { starts: 74, completions: 56 },
      { starts: 79, completions: 58 },
      { starts: 83, completions: 61 },
      { starts: 77, completions: 55 },
      { starts: 85, completions: 63 },
      { starts: 88, completions: 66 },
      { starts: 92, completions: 68 },
    ]),
    funnel: [
      { stage: "Запуски", value: 847 },
      { stage: "Прошли старт", value: 798 },
      { stage: "Середина сценария", value: 701 },
      { stage: "Завершили", value: 612 },
    ],
    sceneDropoff: [
      { scene: "Приветствие", dropoffs: 12 },
      { scene: "Теория", dropoffs: 28 },
      { scene: "Выбор инструмента", dropoffs: 19 },
      { scene: "Практика", dropoffs: 45 },
      { scene: "Тест", dropoffs: 18 },
    ],
    completionSplit: [
      { name: "Дошли до финала", value: 612 },
      { name: "Бросили сценарий", value: 235 },
    ],
    errorsBySession: [
      { label: "0 ошибок", count: 214 },
      { label: "1–2", count: 268 },
      { label: "3–5", count: 142 },
      { label: "6+", count: 89 },
    ],
  },
  {
    daily: buildDailySeries([
      { starts: 1, completions: 0 },
      { starts: 0, completions: 0 },
      { starts: 2, completions: 0 },
      { starts: 3, completions: 1 },
      { starts: 1, completions: 0 },
      { starts: 2, completions: 0 },
      { starts: 4, completions: 0 },
      { starts: 2, completions: 1 },
      { starts: 1, completions: 0 },
      { starts: 3, completions: 0 },
      { starts: 2, completions: 0 },
      { starts: 1, completions: 0 },
      { starts: 2, completions: 0 },
      { starts: 1, completions: 0 },
    ]),
    funnel: [
      { stage: "Запуски", value: 23 },
      { stage: "Сцена 1", value: 18 },
      { stage: "Сцена 2", value: 9 },
      { stage: "Завершили", value: 2 },
    ],
    sceneDropoff: [
      { scene: "Старт", dropoffs: 5 },
      { scene: "Сцена 1", dropoffs: 9 },
      { scene: "Сцена 2", dropoffs: 5 },
      { scene: "Сцена 3", dropoffs: 2 },
    ],
    completionSplit: [
      { name: "Дошли до финала", value: 2 },
      { name: "Бросили сценарий", value: 21 },
    ],
    errorsBySession: [
      { label: "0 ошибок", count: 3 },
      { label: "1–2", count: 4 },
      { label: "3–5", count: 6 },
      { label: "6+", count: 10 },
    ],
  },
  {
    daily: buildDailySeries([
      { starts: 8, completions: 4 },
      { starts: 6, completions: 3 },
      { starts: 14, completions: 8 },
      { starts: 11, completions: 7 },
      { starts: 9, completions: 5 },
      { starts: 18, completions: 11 },
      { starts: 16, completions: 10 },
      { starts: 12, completions: 7 },
      { starts: 10, completions: 6 },
      { starts: 15, completions: 9 },
      { starts: 13, completions: 8 },
      { starts: 11, completions: 7 },
      { starts: 14, completions: 9 },
      { starts: 9, completions: 5 },
    ]),
    funnel: [
      { stage: "Запуски", value: 156 },
      { stage: "Брифинг", value: 142 },
      { stage: "Задания", value: 118 },
      { stage: "Завершили", value: 89 },
    ],
    sceneDropoff: [
      { scene: "Брифинг", dropoffs: 14 },
      { scene: "Задание A", dropoffs: 22 },
      { scene: "Задание B", dropoffs: 18 },
      { scene: "Задание C", dropoffs: 13 },
    ],
    completionSplit: [
      { name: "Дошли до финала", value: 89 },
      { name: "Бросили сценарий", value: 67 },
    ],
    errorsBySession: [
      { label: "0 ошибок", count: 41 },
      { label: "1–2", count: 52 },
      { label: "3–5", count: 38 },
      { label: "6+", count: 25 },
    ],
  },
];

function groupSessionsByDay(sessions, field) {
  const map = new Map();

  sessions.forEach((session) => {
    const raw = session[field];
    if (!raw) return;

    const date = new Date(raw);
    const key = date.toISOString().slice(0, 10);

    map.set(key, (map.get(key) ?? 0) + 1);
  });

  return map;
}

function buildDailyFromSessions(sessions) {
  const startsMap = groupSessionsByDay(sessions, "startedAt");
  const completionsMap = groupSessionsByDay(sessions, "completedAt");
  const days = 14;
  const result = [];

  for (let index = 0; index < days; index += 1) {
    const date = new Date();
    date.setDate(date.getDate() - (days - 1 - index));
    const key = date.toISOString().slice(0, 10);

    result.push({
      date: formatDayLabel(date),
      starts: startsMap.get(key) ?? 0,
      completions: completionsMap.get(key) ?? 0,
    });
  }

  return result;
}

function buildSceneDropoffFromSessions(sessions) {
  const counts = new Map();

  sessions.forEach((session) => {
    const path = session.path ?? [];
    if (!path.length) return;

    const exitScene = path[path.length - 1];
    if (!session.completed) {
      counts.set(exitScene, (counts.get(exitScene) ?? 0) + 1);
    }
  });

  return Array.from(counts.entries())
    .map(([scene, dropoffs]) => ({ scene, dropoffs }))
    .sort((a, b) => b.dropoffs - a.dropoffs);
}

function buildErrorsFromSessions(sessions) {
  const buckets = [
    { label: "0 ошибок", count: 0 },
    { label: "1–2", count: 0 },
    { label: "3–5", count: 0 },
    { label: "6+", count: 0 },
  ];

  sessions.forEach((session) => {
    const errors = session.errors ?? 0;

    if (errors === 0) buckets[0].count += 1;
    else if (errors <= 2) buckets[1].count += 1;
    else if (errors <= 5) buckets[2].count += 1;
    else buckets[3].count += 1;
  });

  return buckets;
}

export function buildChartsFromSessions(sessions, analytics = {}) {
  const starts = analytics.starts ?? sessions.length;
  const completions =
    analytics.completions ?? sessions.filter((item) => item.completed).length;
  const dropped = Math.max(starts - completions, 0);
  const inProgress = sessions.filter(
    (item) => !item.completed && (item.path?.length ?? 0) > 1
  ).length;

  const funnel = [
    { stage: "Запуски", value: starts },
    {
      stage: "В процессе",
      value: Math.max(inProgress, Math.round(dropped * 0.45)),
    },
    { stage: "Завершили", value: completions },
  ];

  return {
    daily: buildDailyFromSessions(sessions),
    funnel,
    sceneDropoff: buildSceneDropoffFromSessions(sessions),
    completionSplit: [
      { name: "Дошли до финала", value: completions },
      { name: "Бросили сценарий", value: dropped },
    ],
    errorsBySession: buildErrorsFromSessions(sessions),
  };
}

export function resolveAnalyticsCharts(gameId, games, sessions, analytics, isDemo) {
  if (isDemo) {
    const index = games?.findIndex((item) => item._id === gameId);
    const variantIndex = index >= 0 ? index % DEMO_CHARTS.length : 0;
    return DEMO_CHARTS[variantIndex];
  }

  if (!sessions.length) {
    return null;
  }

  return buildChartsFromSessions(sessions, analytics);
}

export function getConversionRate(completionSplit) {
  if (!completionSplit?.length) return 0;

  const completed = completionSplit.find(
    (item) => item.name === "Дошли до финала"
  );
  const dropped = completionSplit.find(
    (item) => item.name === "Бросили сценарий"
  );
  const total = (completed?.value ?? 0) + (dropped?.value ?? 0);

  if (!total) return 0;

  return Math.round(((completed?.value ?? 0) / total) * 100);
}
